/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { MerkleOrderbook__factory } from './MerkleOrderbook__factory';
